import React from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';

export interface KpiCard {
  label: string;
  value: string | number;
  subtitle?: string;
  subtitleColor?: string;
  topBorderColor?: string;
}

interface KpiCardGridProps {
  cards: KpiCard[];
  columns?: number;
}

const KpiCardGrid: React.FC<KpiCardGridProps> = ({ cards, columns = 4 }) => {
  const mdSpan = 12 / columns;

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card) => (
        <Grid size={{ xs: 12, sm: 6, md: mdSpan }} key={card.label}>
          <Paper
            elevation={0}
            sx={{
              p: '16px 20px',
              borderRadius: '12px',
              border: '1px solid',
              borderColor: 'divider',
              borderTop: `3px solid ${card.topBorderColor || '#1A5F7A'}`,
              height: '100%',
            }}
          >
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '11px',
                fontWeight: 600,
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                mb: 0.5,
              }}
            >
              {card.label}
            </Typography>
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '28px',
                fontWeight: 800,
                color: 'text.primary',
                lineHeight: 1.2,
              }}
            >
              {card.value}
            </Typography>
            {card.subtitle && (
              <Typography
                sx={{
                  fontSize: '12px',
                  color: card.subtitleColor || 'text.secondary',
                  mt: 0.5,
                }}
              >
                {card.subtitle}
              </Typography>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default KpiCardGrid;
